import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
} from "@angular/common/http";
import { environment } from "../../../environments/environment";
import "rxjs/add/operator/map";
import { ICountry } from "../../master-models/country.model";
import { Observable } from "rxjs";

interface IResponse {
  success: boolean;
  data: ICountry[];
  message: string
}

@Injectable()
export class CountryService {
  apiEndPoint = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getCountriesList(): Observable<IResponse> {
    return this.http.get<IResponse>(`${this.apiEndPoint}api/countries`, {
      headers: this.getHeaders()
    });
  }

  getHeaders(): HttpHeaders {
    const token = localStorage.getItem("token_user");
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/master-services/countries/country.service.ts